const navKey = 'navTitles'

export function getNavTitles() {
  return JSON.parse(sessionStorage.getItem(navKey)) || []
}

export function setNavTitles(navsArr) {
  return sessionStorage.setItem(navKey, JSON.stringify(navsArr || []))
}

export function removeNavTitles() {
  return sessionStorage.removeItem(navKey)
}

const remendIDKey = 'remendID'

export function getRemendID() {
  console.log("sessionStorage-getRemendID");
  return sessionStorage.getItem(remendIDKey) || 0
}

export function setRemendID(ID) {
  console.log("sessionStorage-getRemendID",);
  return sessionStorage.setItem(remendIDKey, ID || 0)
}
